import React from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FaUsers,
  FaClipboardList,
  FaUserTie,
  FaRupeeSign,
  FaPlaneDeparture,
  FaUser,
  FaBuilding,
  FaRoad,
  FaList,
} from "react-icons/fa";
import "../../../assets/css/Sidebar.css";
import { RiUser2Fill } from "react-icons/ri";
import { MdSpaceDashboard } from "react-icons/md";
import { BsListCheck } from "react-icons/bs";

function SuperAdminSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const superAdminMenuItems = [
    {
      id: "1",
      name: "Dashboard",
      icon: <MdSpaceDashboard />,
      path: "/SuperAdminDashboard",
    },
    {
      id: "2",
      name: "Fund Managment",
      icon: <FaRupeeSign />,
      path: "/superadmin/fund-management",
    },
    {
      id: "3",
      name: "Department Managment",
      icon: <FaBuilding />,
      path: "/superadmin/department-management",
    },
    {
      id: "4",
      name: "User Management",
      icon: <FaUser />,
      path: "/superadmin/user-management",
    },
    {
      id: "5",
      name: "PWD Report List",
      icon: <FaRoad />,
      path: "/superadmin/pwdreportlist",
    },
    // --- Manage trade types  Added Here ---
    {
      id: "trade-types",
      name: "Manage Trade Types",
      icon: <BsListCheck />,
      path: "/superadmin/trade-types",
    },
    
  ];

  const handleItemClick = (path) => {
    navigate(path);
  };

  return (
    <div className="sidebar">
      <ul className="sidebar-menu">
        {superAdminMenuItems.map((item, index) => (
          <motion.li
            key={item.id}
            // Updated active class logic for better matching on nested routes
            className={`menu-item ${
              location.pathname.startsWith(item.path) ? "active" : ""
            }`}
            onClick={() => handleItemClick(item.path)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
          >
            <span className="icon">{item.icon}</span>
            <span className="text">{item.name}</span>
          </motion.li>
        ))}
      </ul>
    </div>
  );
}

export default SuperAdminSidebar;
